
export type LogoType = "contacts" | "brands";

export default defineNuxtPlugin({
  parallel: false,
  setup: () => {
    const { $config } = useNuxtApp();

    function imageSrc(image: String) {
      if (!image) {
        return undefined;
      }
      return `${$config.public.imagesBaseUrl}/${image.slice(0, 1)}/${image.slice(1, 2)}/${image.slice(2, 3)}/${image}`;
    }

    function logoSrc(id: number, type: LogoType, ext: String, modified?: number) {
      const m = Math.floor(id / 1000000);
      const k = Math.floor((id - m * 1000000) / 1000);
      return `${$config.public.logosBaseUrl}/${type}/${m}/${k}/${id}.${ext}${modified ? `?t=${Date.now()}` : ''}`;
    }
    return {
      provide: {
        imageSrc,
        logoSrc,
      }
    }
  },
});